export default "__VITE_ASSET__DGpfoklR__"